import { defineColumnInterface } from "../../lib/defines";
import Component from "./component";

export default defineColumnInterface({
  id: "list-o2m",
  component: Component,
});
